<template id="listefiltres">
  <div class="listefiltres">
    <ul>
      <!-- Type de condamnation -->
      <li v-if="filtres.typeCondChoix && filtres.typeCondChoix == 'animal'">
        Santé et bien-être animal
      </li>
      <li v-else>Établissement alimentaire</li>
      <!-- Type d'établissement -->
      <li v-if="filtres.typeCond && filtres.typeCond == '0'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Autres
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '1'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Aquatique
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '2'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Produits carnés
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '3'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Eaux et breuvages
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '4'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Érable
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '5'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Lait
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '6'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Miel
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '8'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Production de végétaux
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '20'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Détail
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '21'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Restauration
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '31'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Santé animal
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '32'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Bien-être animal
      </li>
      <li v-if="filtres.typeCond && filtres.typeCond == '99'">
        <button @click="onClickResetTypeCond" type="button">
          <span>x</span></button
        >Générale
      </li>
      <li
        v-if="filtres.poursuivant && filtres.poursuivant == 'VILLE DE MONTREAL'"
      >
        <button @click="onClickResetPoursuivant" type="button">
          <span>x</span></button
        >Poursuivant : Cour municipale de Montréal
      </li>
      <li v-if="filtres.poursuivant && filtres.poursuivant == 'MAPAQ'">
        <button @click="onClickResetPoursuivant" type="button">
          <span>x</span></button
        >Poursuivant : Palais de justice de Québec
      </li>
      <!-- Le reste (ville, établissement, dates) -->
      <li v-if="filtres.ville">
        <button id="reset_ville" @click="onClickResetVille" type="button"><span>x</span></button
        >{{ filtres.ville }}
      </li>
      <li v-if="filtres.etablissement">
        <button id="reset_etablissement" @click="onClickResetEtablissement" type="button">
          <span>x</span></button
        >{{ filtres.etablissement }}
      </li>
      <li v-if="filtres.date1Formatted">
        <button @click="onClickResetDate1" type="button"><span>x</span></button
        >Date de publication à partir du : {{ filtres.date1Formatted }}
      </li>
      <li v-if="filtres.date2Formatted">
        <button @click="onClickResetDate2" type="button"><span>x</span></button
        >Date de publication jusqu'au : {{ filtres.date2Formatted }}
      </li>
      <li v-if="filtres.date3Formatted">
        <button @click="onClickResetDate3" type="button"><span>x</span></button
        >Date de l'infraction à partir du : {{ filtres.date3Formatted }}
      </li>
      <li v-if="filtres.date4Formatted">
        <button @click="onClickResetDate4" type="button"><span>x</span></button
        >Date de l'infraction jusqu'au : {{ filtres.date4Formatted }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ListeFiltres',
  components: {},
  emits: ['resetFiltre'],
  props: {
    filtres: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClickResetVille() {
      let type = 'ville';
      this.$emit('resetFiltre', type);
    },
    onClickResetEtablissement() {
      let type = 'etablissement';
      this.$emit('resetFiltre', type);

    },
    onClickResetPoursuivant() {
      let type = 'poursuivant';
      this.$emit('resetFiltre', type);
    },
    onClickResetDate1() {
      let type = 'date1';
      this.$emit('resetFiltre', type);
    },
    onClickResetDate2() {
      let type = 'date2';
      this.$emit('resetFiltre', type);
    },
    onClickResetDate3() {
      let type = 'date3';
      this.$emit('resetFiltre', type);
    },
    onClickResetDate4() {
      let type = 'date4';
      this.$emit('resetFiltre', type);
    },
    onClickResetTypeCond() {
      let type = 'typeCond';
      this.$emit('resetFiltre', type);
    },
    onClickResetTypeCondChoix() {
      let type = 'typeCondChoix';
      this.$emit('resetFiltre', type);
    },
  },
  computed: {},
};
</script>
